import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import { assetUrl } from '../utils/assetUrl';

const Heading = styled.h1`
  margin: 0 0 ${theme.space[4]}px;
  font-family: ${theme.fonts.display};
  font-size: ${theme.fontSizes.hero};
  line-height: 1.05;
`;

const Intro = styled.p`
  margin: 0 0 ${theme.space[6]}px;
  color: ${theme.colors.muted};
  max-width: 70ch;
  line-height: 1.6;
`;

const List = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[4]}px;
`;

const Card = styled.article`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  border: 1px solid ${theme.colors.border};
  background: ${theme.colors.surface};
  border-radius: ${theme.radii.md}px;
  overflow: hidden;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const PortraitWrap = styled.div`
  flex: 0 0 auto;
  width: min(280px, 40%);
  background: ${theme.colors.gallery};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.space[4]}px;

  @media (max-width: 640px) {
    width: 100%;
    max-width: none;
  }
`;

const Portrait = styled.img`
  max-width: 100%;
  max-height: 220px;
  width: auto;
  height: auto;
  display: block;
  image-rendering: pixelated;
  image-rendering: crisp-edges;
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
  padding: ${theme.space[5]}px ${theme.space[6]}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Name = styled.h2`
  margin: 0 0 ${theme.space[3]}px;
  font-family: ${theme.fonts.display};
  font-size: ${theme.fontSizes.xl};
`;

const Bio = styled.p`
  margin: 0;
  color: ${theme.colors.text};
  line-height: 1.65;
`;

const Status = styled.p`
  color: ${({ $error }) => ($error ? theme.colors.accent : theme.colors.muted)};
  font-size: ${theme.fontSizes.sm};
`;

export function Characters() {
  const [characters, setCharacters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/characters/characters.json`)
      .then((res) => {
        if (!res.ok) throw new Error('Could not load characters');
        return res.json();
      })
      .then((items) => setCharacters(items))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Status>Loading characters…</Status>;
  if (error) return <Status $error>{error}</Status>;

  return (
    <>
      <Heading>Characters</Heading>
      <Intro>
        My original characters that I have created and worldbuilt for.
      </Intro>
      <List>
        {characters.map((character) => (
          <Card key={character.id}>
            <PortraitWrap>
              <Portrait src={assetUrl(character.imageUrl)} alt={character.name} />
            </PortraitWrap>
            <Content>
              <Name>{character.name}</Name>
              <Bio>{character.bio}</Bio>
            </Content>
          </Card>
        ))}
      </List>
    </>
  );
}
